// @flow
import React from 'react';
import classNames from 'classnames';
import arrowLongRight from 'assets/images/arrowLongRightGray.png';
import arrowLongRightCoral from 'assets/images/arrowLongRightHighlight.png';
import arrowRightCoral from 'assets/images/RIGHT.png';
import calendarBlack from 'assets/images/calendarBlack.png';
import arrowRightWhite from 'assets/images/Total Environment_Website_Icon_Library Arrow_White.png';
import arrowRightBlack from 'assets/images/Total Environment_Website_Icon_Library Arrow_Black.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  text: string,
  onClick: () => void,
  type?: 'button' | 'link',
  size?: 'small' | 'regular',
  mode?: 'dark' | 'light' | 'transparent',
  className?: string,
  isMobile?: boolean,
  iconType?: string,
  iconSmall?: boolean,
};

const DEFAULT_CTA = 'Explore';

export const CallToAction = (props: Props) => {
  const {
    text = DEFAULT_CTA,
    onClick,
    type = 'button',
    size = 'regular',
    mode = 'light',
    className = '',
    isMobile = false,
    iconType = '',
    iconSmall = false,
    updateWidth,
    isCustomLink = false,
  } = props;

  const imageSource =
    iconType === 'events-button'
      ? calendarBlack
      : mode === 'transparent'
      ? isMobile
        ? arrowRightCoral
        : arrowLongRightCoral
      : arrowLongRight;

  const smallIconSource = mode === 'dark' ? arrowRightWhite : arrowRightBlack;

  // add conditional classes
  const buttonClass = classNames(
    'cta-button',
    className,
    iconType,
    updateWidth,
    {
      dark: mode === 'dark',
      light: mode === 'light',
      transparent: mode === 'transparent',
      regular: size === 'regular',
      small: size === 'small',
      link: type === 'link',
    }
  );

  return !isCustomLink ? (
    <button onClick={onClick} type={'button'} className={buttonClass}>
      <span>{text}</span>
      <img src={iconSmall ? smallIconSource : imageSource} alt={'arrow icon'} />
    </button>
  ) : (
    <a className={buttonClass} href={'#contact'}>
      <span>{text}</span>
      <img src={iconSmall ? smallIconSource : imageSource} alt={'arrow icon'} />
    </a>
  );
};
